const statuses = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'LIVE', label: 'Live' },
  { value: 'ARCHIVED', label: 'Archived' }
]

export default statuses
